import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
  name: "profile-psychologist",
  component: () => import(/* webpackChunkName: "auth-layout" */ "@/layouts/PrincipalLayout.vue"),
  children: [
    {
      path: "",
      name: "profile-psychologist-index",
      beforeEnter: [isVerifyTokenGuard],
      component: () => import(/* webpackChunkName: "demo-childres" */ "../views/Index.vue"),
    },
    
  ],
}; 
